import React from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import isUndefined from 'lodash/isUndefined';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { IHotelsState, IMenuState, resetHotels, setVisible } from 'src/store/slices/index';
import { isExternalUrl } from 'src/utils/index';
import { RootState } from 'src/store';
import { Routes } from 'src/constants/index';
import './style.scss';

interface IMapStateToProps {
  hotelsStore: IHotelsState;
}

interface IMapDispatchToProps {
  resetHotels: () => void;
  setVisible: (visible: boolean) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps {
  matches: boolean;
  menuStore: IMenuState;
}

const HOTELS = 'Hotels';

class NavMenu extends React.Component<IProps> {
  reloadSamePage = (event: { target: HTMLInputElement }, namePage: string) => {
    this.props.setVisible(false);

    if (event.target.innerText === namePage && this.props.hotelsStore.hotels) {
      this.props.history.push(`${Routes.Search}`);
      window.location.reload();
    }
  };

  // @ts-ignore
  menuItem = (url: string, title: string, index: number, className: string): React.ReactNode => (
    <Menu.Item key={`${title}-${index}`} className="header__item-menu">
      {isExternalUrl(!isUndefined(url) ? url : '') ? (
        <a className={className} href={url} target="_blank" rel="noreferrer">
          {title}
        </a>
      ) : (
        <Link
          to={!isUndefined(url) ? url : '/'}
          className={className}
          // @ts-ignore
          onClick={(event) => this.reloadSamePage(event, HOTELS)}
        >
          {title}
        </Link>
      )}
    </Menu.Item>
  );

  render(): React.ReactNode {
    const { SubMenu } = Menu;
    const { matches, menuStore } = this.props;
    const { visible, items } = menuStore;

    return (
      <Menu
        mode={visible && !matches ? 'inline' : 'horizontal'}
        style={{
          display: !visible ? (!matches ? 'none' : 'block') : 'block',
        }}
      >
        {items?.main.map((item, index) =>
          !item.childItems ? (
            this.menuItem(item.url, item.title, index, 'header__link-nav')
          ) : (
            <SubMenu
              key={`${item.title}-${index}`}
              title={<span>{item.title}</span>}
              className="header__sub-menu"
              popupClassName="menu-submenu-popup"
            >
              {item?.childItems.map((childItem) =>
                this.menuItem(childItem.url, childItem.title, index, 'header__link-nav-child'),
              )}
            </SubMenu>
          ),
        )}
      </Menu>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    hotelsStore: state.hotelsStore,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, undefined, Action>,
): IMapDispatchToProps => ({
  resetHotels: () => {
    dispatch(resetHotels());
  },
  setVisible: () => {
    dispatch(setVisible());
  },
});

export const NavigationMenu = connect(mapStateToProps, mapDispatchToProps)(withRouter(NavMenu));
